<template>
  <div class="gamePage">
    <div class="selectContainer">
      <div class="selectList">
        <div class="selectItem" v-for="(item, index) in topList" :key="index" @click="selectType(item.value)">
          <img :src="showType===item.value?item.srcAct:item.src" alt="">
          <div :class="{'labelAct':showType===item.value}">{{item.label}}</div>
        </div>
      </div>
    </div>
    <div class="gameContainer">
      <div class="searchRow">
        <label>
          <input type="text" v-model="searchText" @input="handelInput">
        </label>
        <img :src="imgList['search']" alt="" @click="searchGames">
      </div>
      <div ref="gameContent" class="gameContent">
        <div ref="scroll">
          <Loadmore
            :bottomPullText="'pull to load more'"
            :bottomDropText="'release to load more'"
            :bottomLoadingText="'loading'"
            :auto-fill="false"
            :bottom-method="() => {
              searchGames(true)
            }"
            :bottom-all-loaded="hasLoadAll"
            ref="loadmore">
            <div
              class="game"
              :class="{'last': index%3===2}"
              v-for="(item, index) in gameList"
              :key="index"
              @click="fetchGame(item)"
            >
              <div class="imgContainer">
                <img :src="item.ThumbnailUrl" alt="">
                <div class="imgMask"/>
              </div>
              <p>{{item.GameNameEn}}</p>
            </div>
            <div class="showMore" v-if="!hasLoadAll"><img :src="showMore" alt=""></div>
          </Loadmore>
        </div>
      </div>
    </div>
    <GameIframe :gameInfo="gameInfo" v-if="showGame"/>
  </div>
</template>

<script>
import {Loadmore, Toast} from 'mint-ui'
import request from '@/service'
import GameIframe from '@/components/GameIframe/index'
import showMore from '@/assets/images/common/showMore.gif'

const context = require.context('@/assets/images/GamePage', true, /\.svg$/)
const imgList = {}
context.keys().forEach((key) => {
  imgList[key.replace('./', '').replace('.svg', '')] = context(key)
})
export default {
  name: 'Games',
  data () {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
      imgList,
      topList: [
        {
          label: 'All Games',
          value: '',
          src: imgList['All'],
          srcAct: imgList['All_act']
        },
        {
          label: 'Most Popular',
          value: 'mostpopular',
          src: imgList['Popular'],
          srcAct: imgList['Popular_act']
        },
        {
          label: 'Live Dealers',
          value: 'livecasino',
          src: imgList['Live'],
          srcAct: imgList['Live_act']
        },
        {
          label: 'Baccarat',
          value: 'baccarat',
          src: imgList['Baccarat'],
          srcAct: imgList['Baccarat_act']
        },
        {
          label: 'Blackjack',
          value: 'blackjack',
          src: imgList['Blackjack'],
          srcAct: imgList['Blackjack_act']
        },
        {
          label: 'Slots',
          value: 'slots',
          src: imgList['Slots'],
          srcAct: imgList['Slots_act']
        }
      ],
      searchText: 'mostpopular',
      showType: 'mostpopular',
      gameList: [],
      takeNum: 15,
      skipNum: 0,
      hasLoadAll: true,
      delaySearch: null,
      gameInfo: {},
      showGame: false,
      firstLoad: true,
      showMore
    }
  },
  components: {
    Loadmore,
    GameIframe
  },
  mounted () {
    this.searchGames()
  },
  methods: {
    selectType (label) {
      this.showType = label
      this.searchText = label
      this.searchGames(label)
    },
    handelInput () {
      this.showType = ''
      clearTimeout(this.delaySearch)
      this.delaySearch = setTimeout(() => this.searchGames(false, true), 1000)
    },
    searchGames (loadMore, noloading) {
      if (loadMore !== true) {
        this.skipNum = 0
        this.gameList = []
        this.firstLoad = true
        this.hasLoadAll = true
      }
      const url = '/innovation/game/searchgames'
      const data = {
        searchText: this.searchText,
        skip: this.skipNum,
        take: this.takeNum
      }
      request('post', url, data, noloading).then(res => {
        if (loadMore === true) {
          this.gameList = this.gameList.concat(res.Games)
        } else {
          this.gameList = res.Games
        }
        this.skipNum += this.takeNum
        this.hasLoadAll = this.skipNum >= res.Total
        if (!this.firstLoad) {
          this.$refs.loadmore.onBottomLoaded()
        }
        this.firstLoad = false
      })
    },
    fetchGame (game) {
      if (this.userInfo && this.$store.state.banUserId.includes(this.userInfo.UserId)) {
        Toast(this.$t('lang.home.gameMaintenancePrompt'))
        return
      }
      const url = '/innovation/game/getgameurl'
      const data = {
        userId: this.userInfo.UserId || '',
        gameCode: game.GameCode,
        gameProviderId: game.GameProviderId,
        deviceWidth: document.body.clientWidth,
        lang: localStorage.getItem('locale')
      }
      request('post', url, data).then(res => {
        if (res.Url) {
          this.gameInfo = {
            gameUrl: res.Url,
            gameImg: game.ThumbnailUrl,
            gameName: game.GameNameEn
          }
          this.showGame = true
        } else {
          Toast('Fail')
        }
      })
    },
    close () {
      this.showGame = false
    }
  }
}
</script>

<style lang="less" scoped>
  .gamePage {
    height: 100%;
    overflow: hidden;
    .selectContainer {
      height: 100px;
      overflow: auto;
      padding: 15px 0;
      background-color: #000;
      .selectList {
        display: flex;
        align-items: center;
        padding-left: 35px;
        width: max-content;
        .selectItem {
          text-align: center;
          margin-right: 35px;
          div {
            font-size: 12px;
            margin-top: 4px;
            width: 100%;
            min-width: max-content;
          }
          .labelAct {
            font-size: 14px;
            color: #F6D9AA;
          }
        }
      }
    }
    .gameContainer {
      height: calc(100% - 100px);
      padding: 10px 16px;
      .searchRow {
        position: relative;
        height: 40px;
        input {
          width: 100%;
          height: 100%;
          background-color: #000;
          font-size: 16px;
          color: #686868;
          border-radius: 6px;
          padding-left: 17px;
          padding-right: 30px;
        }
        img {
          position: absolute;
          top: 50%;
          right: 7px;
          transform: translateY(-50%);
        }
      }
      .gameContent {
        height: calc(100% - 60px);
        margin-top: 20px;
        overflow: auto;
        .game {
          width: 32%;
          margin-right: 2%;
          margin-bottom: 20px;
          float: left;
          .imgContainer {
            position: relative;
            height: 0;
            padding-bottom: 75.1%;
            overflow: hidden;
            border-radius: 6px;
            img {
              width: 100%;
              border-radius: 6px;
            }
            .imgMask {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 85px;
              background: linear-gradient(180deg, rgba(0, 0, 0, 0) 58.82%, #000000 120.45%);
            }
          }
          p {
            width: 100%;
            font-size: 12px;
            line-height: 14px;
            color: #C4C4C4;
            margin-top: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .last {
          margin-right: 0;
        }
        .showMore {
          text-align: center;
          img {
            width: 10px;
          }
        }
        /deep/ .mint-loadmore-content {
          position: relative;
          &:after{
            content: "020";
            display: block;
            height: 0;
            clear: both;
            visibility: hidden;
          }
          .mint-loadmore-bottom {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            height: 20px;
            line-height: 20px;
            margin-bottom: -20px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Games/index.vue